module.exports = __webpack_public_path__ + "static/media/off-white-acid-free.e9b27243.jpg";